import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';
import { Loader } from 'src/components/placeholders/loader';
import { AuthGuard } from 'src/guards/auth-guard';
import { CapabilitiesGuard } from 'src/guards/capabilities-guard';
import { Layout } from 'src/layouts/default';
import { paths } from 'src/paths';

// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const FeedPage = lazy(() => import('src/pages/user/feed'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const PostPage = lazy(() => import('src/pages/user/feed/post'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const NewsletterPage = lazy(() => import('src/pages/user/feed/newsletter'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const DocumentsPage = lazy(() => import('src/pages/user/documents'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const CalendarPage = lazy(() => import('src/pages/user/calendar'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const ChatPage = lazy(() => import('src/pages/user/chat'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const WikiPage = lazy(() => import('src/pages/user/wiki'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const UserMemberPage = lazy(() => import('src/pages/user/account'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const UserCompanyPage = lazy(() => import('src/pages/user/company'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const AdminCompanyPage = lazy(() => import('src/pages/admin/company'));
// prettier-ignore
// eslint-disable-next-line react-refresh/only-export-components
const AdminMemberPage = lazy(() => import('src/pages/admin/company/member'));

export const userRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout>
          <Suspense fallback={<Loader />}>
            <Outlet />
          </Suspense>
        </Layout>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <FeedPage />
      },
      {
        path: 'newsletter/:id',
        element: <NewsletterPage />
      },
      {
        path: 'post/:id',
        element: <PostPage />
      },
      {
        path: 'documents/:id?',
        element: <DocumentsPage />
      },
      {
        path: 'calendar',
        element: <CalendarPage />
      },
      {
        path: 'chat/:channel?',
        element: <ChatPage />
      },
      {
        path: 'wiki/:mode?/:id?',
        element: <WikiPage />
      },
      {
        path: 'account',
        element: <UserMemberPage />
      },
      {
        path: 'company',
        children: [
          {
            index: true,
            element: (
              <CapabilitiesGuard
                validate={({ management }) => !management}
                redirect={paths.company.admin}
              >
                <UserCompanyPage />
              </CapabilitiesGuard>
            )
          },
          {
            path: 'edit',
            element: (
              <CapabilitiesGuard
                validate={({ management }) => management}
                redirect={paths.company.user}
              >
                <AdminCompanyPage />
              </CapabilitiesGuard>
            )
          },
          {
            path: 'member/:id',
            element: (
              <CapabilitiesGuard
                validate={({ management }) => management}
                redirect={paths.company.user}
              >
                <AdminMemberPage />
              </CapabilitiesGuard>
            )
          }
        ]
      }
    ]
  }
];
